import React from 'react';
import {connect} from 'react-redux';

const Loading = ({loading}) => loading && (
    <div className="loading-wrapper">
        <div className="loading" />
    </div>
);

const mapStateToProps = ({request}) => ({
    loading: (request && request.immediate) || false,
});

export default connect(mapStateToProps)(Loading);
